<template>
  <v-container>
    <v-app-bar dark app color="primary">
      <v-btn icon>
        <v-icon>mdi-clock-outline</v-icon>
      </v-btn>
      <v-toolbar-title>Stundenplan</v-toolbar-title>
      <template v-slot:extension>
        <v-tabs align-with-title>
          <v-tabs-slider color="error"></v-tabs-slider>
          <v-tab :to="{ name: 'TimetableUpload' }"> Veröffentlichen </v-tab>

          <v-tab :to="{ name: 'TimetableWishes' }"> Wünsche </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
    <router-view />
  </v-container>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "Optional",
  data() {
    return {};
  },
});
</script>
